module.exports = __webpack_public_path__ + "static/img/20010 (4).d7c81e0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20010 (4).webp
// module id = hbXy
// module chunks = 14